module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row type-and-template-wrapper"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "type-action-picker-wrapper form-group"
  }, [_c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "name": "action_parameters",
      "options": _vm.type_options,
      "disabled": _vm.options.disabled || !_vm.flow.canEditActions()
    },
    on: {
      "input": _vm.typeChanged
    },
    model: {
      value: (_vm.action_parameters),
      callback: function($$v) {
        _vm.action_parameters = $$v
      },
      expression: "action_parameters"
    }
  })], 1)]), _c('div', {
    staticClass: "col-sm-8 no-padding"
  }, [_c('div', {
    staticClass: "template-picker-wrapper"
  }, [_c('template-picker', {
    attrs: {
      "reference": _vm.reference,
      "action": _vm.action,
      "flow": _vm.flow,
      "templates": _vm.templates,
      "template_kind": _vm.template_kind,
      "validate": _vm.is_email_flow_action,
      "options": _vm.options
    },
    on: {
      "change": _vm.templateChanged,
      "cancel-editing": _vm.cancelTemplateEdit
    }
  })], 1)]), _c('div', {
    staticClass: "col-sm-1 no-padding text-center"
  }, [_c('div', {
    staticClass: "send-as-reply-wrapper",
    class: {
      hidden: _vm.hide_send_as_reply
    }
  }, [_c('div', {
    staticClass: "checkbox-inline reply-checkbox no-margin",
    attrs: {
      "id": "send-as-reply"
    },
    on: {
      "click": _vm.toggleSendAsReply
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.send_as_reply
    }
  }), _c('label', {
    staticClass: "control-label single-line-tooltip",
    attrs: {
      "data-toggle": "tooltip",
      "data-title": _vm.$t('flows.actions.sendAsReply')
    }
  }, [_vm._v(" ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57208104!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow_actions/picker/type.vue
// module id = 1129
// module chunks = 1